export default __webpack_public_path__ + "static/media/9.aa4cfe87.jpg";